import React from 'react';
import Unescaped from '~components/Atoms/Unescaped';

export interface iWidgetSection {
  children: React.ReactNode;
  title: string;
  info?: string;
}

export default function WidgetSection({ children, title, info }: iWidgetSection) {
  return (
    <section className="mx-4 md:mx-8 my-8 min-h-[400px]">
      <div className="mb-8 ml-6 max-w-[1200px]">
        <h3 className="text-2xl font-semibold mb-4">{title}</h3>
        {info && (
          <p>
            <Unescaped>{info}</Unescaped>
          </p>
        )}
      </div>
      <div className="w-full my-0 mx-auto space-y-8">{children}</div>
    </section>
  );
}
